define([
    "dojo/_base/declare",
    "dojo/dom-style",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dojo/text!./CrossOut.html"
], function(declare, domStyle, _WidgetBase, _TemplatedMixin, template){
    return declare([_WidgetBase, _TemplatedMixin], {
    	//Widget used to crossOut images or containers.
    	//This will take 100% width of the container
    	
        templateString: template,
        // top,width,left will determine the positioning and width of the cross
        top: "50",
        width: "100",
        left: "0"
    });
});